var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Inject } from 'vue-property-decorator';
import { INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
let ZoomToolbarWidget = class ZoomToolbarWidget extends Vue {
  constructor() {
    super(...arguments);
    this.dropDownOpt = [50, 67, 75, 80, 90, 100];
  }
  renderDropDown() {
    const h = this.$createElement;
    return h("a-dropdown", {
      "attrs": {
        "trigger": ['click']
      }
    }, [h("button", {
      "class": 'ucd-toolbar-zoom-button-center'
    }, [`${this.designer.zoom}%`]), h("div", {
      "slot": "overlay",
      "class": "ucd-toolbar-zoom-dropdownMenu"
    }, [this.dropDownOpt.map(newZoom => h("div", {
      "class": "ucd-toolbarPopMenu-item",
      "on": {
        "click": () => {
          this.designer.changeZoomByUser(newZoom);
        }
      }
    }, [`${newZoom}%`]))])]);
  }
  render() {
    const h = arguments[0];
    return h("a-tooltip", {
      "class": 'ucd-toolbar-zoom',
      "attrs": {
        "placement": "bottomRight",
        "destroyTooltipOnHide": true
      }
    }, [h("button", {
      "class": 'ucd-toolbar-zoom-button',
      "on": {
        "click": () => this.designer.addToZoom(-10)
      }
    }, ["-"]), this.renderDropDown(), h("button", {
      "class": 'ucd-toolbar-zoom-button',
      "on": {
        "click": () => this.designer.addToZoom(10)
      }
    }, ["+"])]);
  }
};
__decorate([Inject(INJECT_UICORE_DESIGNER)], ZoomToolbarWidget.prototype, "designer", void 0);
ZoomToolbarWidget = __decorate([Component({
  name: 'ZoomToolbarWidget'
})], ZoomToolbarWidget);
export default ZoomToolbarWidget;
//# sourceMappingURL=ZoomToolbarWidget.js.map
